import { GENDER } from "@constants/index";

import { RTFile } from "./file";

export enum Gender {
  NA = "N/A",
  MALE = "MALE",
  FEMALE = "FEMALE",
}

export enum UserRole {
  ADMIN = "ADMIN",
  USER = "USER",
  FREELANCER = "FREELANCER",
}

export type User = {
  id: string;
  username: string;
  email: string;
  name: string;
  skillTag: string;
  level: string;
  location: string;
  workingSchedule: string;
  role: UserRole;
  avatar: string;
  stripeCustomerId?: string;
  stripeAccountId?: string;
  phoneNumber: string;
  gender: Gender;
  dateOfBirth: string;
  files?: RTFile[];
  createdAt?: string;
  bio?: string;
  experiences?: any[];
  hourRateFrom?: number;
  hourRateTo?: number;
  link?: any[];
  userLanguages?: any[];
  virtualOrderNumber?: number;
  virtualTotalEarn?: number;
  profileProjects?: any[];
  withdrawableBalance?: string | number;
  // for invitation
  isLeave?: boolean;
  voteWeight?: number;
  institution?: string;
  description?: string;
  restrictedEmail?: string[];
};

export enum RestrictedEmail {
  DAILY_JOB_UPDATES = "daily-job-updates",
  P2P_EMAIL_ALERT = "p2p-email-alert",
}

export type UserManagement = {
  id: string;
  avatar?: string;
  name: string;
  email: string;
  gender: keyof typeof GENDER;
  level: string;
  dateOfBirth: number;
  phoneNumber: string;
  location: string;
  workingSchedule: string;
  createdAt: string;
};
